import * as types from '../mutation-types'
import {http} from '../../lib/http'

const state = {
    currentAccountId: null,
    account: {tarif: {}, segmentation:{}},
    projects: [],
    folders: [],
    user: {},
    domains: [],
    pages: [],
    tasks: [],
    tasksGroups: [],
    contacts: [],
    bills: [],
    integrations: [],
    logs: [],
    errors: [],
    leads: [],
    users: [],
    tariffs: [],
    changeTarif: {}
}

const paySystems = ['n/a', 'Яндекс', 'Робокасса', 'Payler', 'CARD', 'Ручное', 'Безнал'];

const getters = {
    bills(state) {
        return state.bills.map((bill) => {
            if (bill.pay_system) {
                bill.pay_system_title = paySystems[bill.pay_system];
            }
            return bill;
        })
    },

    pages(state) {
        var domains = _.cloneDeep(state.pages);
        return domains.map((domain) => {
            domain.pages = _.map(domain.pages, function(page) {
                page.project_title = !page.project_id? null : _.get(_.find(state.projects, {id: page.project_id}), 'title')
                page.folder_title = !page.folder_id? null : _.get(_.find(state.folders, {id: page.folder_id}), 'title')
                return page
            })

            domain.project_title = !domain.project_id? null : _.get(_.find(state.projects, {id: domain.project_id}), 'title')
            domain.folder_title = !domain.folder_id? null : _.get(_.find(state.folders, {id: domain.folder_id}), 'title')

            return domain
        })
    }
}

var mutations = {
    

    [types.SET_CURRENT_ACCOUNT_ID] (state, data) {
        state.currentAccountId = data
    },

    'SET_BILLS' (state, data) {
        state.bills = data.map((row) => {
            row.amount = parseFloat(row.amount)
            return row
        })
    },

    'SET_TASKS' (state, data) {
        
        state.tasks = data;
        
        var groups = {};
        if (data && data.length)
        data.forEach((task) => {
            if (!groups[task.status]) {
                groups[task.status] = 1
            } else {
                groups[task.status]++
            }
        })
        state.tasksGroups = groups;
    }

}

const objects = ['account', 'user', 'pages', 'domains', 'contacts',
    'bills', 'tasks', 'integrations', 'logs', 'errors', 'leads', 'users', 'tariffs', 'projects', 'folders'];

objects.forEach((obj) =>{
    var key = 'SET_'+obj.toUpperCase();
    if (!mutations[key]) {
        mutations[key] = (state, data) => {
            state[obj] = data
        };
    }
});

const REQ_POST = 'post'
const REQ_GET = 'get'

var action = function(context, action, method = REQ_GET, params = {}, reload = true) {
    console.log(action, method, '/accounts/' + context.state.account.id + '/'+action);
    var pr = http.req(method, '/accounts/' + context.state.account.id + '/'+action, params)
    if (reload) {
        pr.then(() => context.dispatch('loadAccount') )
    }
    return pr
}


const actions = {
    setCurrentAccountId({state, commit, dispatch}, accountId) {
        // проверка, чтобы страница аккаунта не перезагружалась при переходе по вкладкам
        if (state.currentAccountId !== accountId) {
            commit(types.SET_CURRENT_ACCOUNT_ID, accountId)
            dispatch('loadAccount')
        }
    },

    loadAccount({state, dispatch, commit}) {
        http.get('/api/accounts/'+state.currentAccountId).then((data)=>{
            commit(types.SET_ACCOUNT, data);
            console.log('account loaded')
            dispatch('toggleSearch', false, { root: true })
            if (data.user) {
                commit(types.SET_USER, data.user);
            }
        })
    },
    
    loadRelated({state, commit}, modelName) {
        http.get('/api/accounts/'+state.account.id+'/'+modelName).then((data)=>{
            commit('SET_'+modelName.toUpperCase(), data);
        })
    },
    
    pageMove ({dispatch}, {page, account_id, pageId}) {
        return http.get('/api/accounts/'+account_id).then(function(data){
            if (!data.id) {
                return vex.dialog.alert('Указанный аккаунт не найден: ' . account_id)
            }
            return http.post('/api/pages/'+(pageId || page.id)+'/move', { account_id })
        })
    },
    taskRestart({dispatch}, task) {
        http.post('/api/tasks/'+task.id+'/restart').then((data) => {
            dispatch('loadRelated', 'tasks')
        })
    },

    editUser({state, dispatch}, user) {
        return http.post('/api/accounts/'+state.account.id+'/editUser', user).then((data) => {
            dispatch('loadAccount')
        })
    },

    billPay({dispatch}, {bill, value}) {
        http.post('/api/bills/'+bill.id+'/pay', {
            number: value
        }).then((data) => {
            dispatch('loadRelated', 'bills')
        })
    },
    
    billRetry({dispatch}, bill) {
        return http.post('/api/bills/'+bill.id+'/retry').then((data) => {
            console.log('inside', data);
        })
    },
    
    block(context, reason) {
        return action(context, 'block', REQ_POST, { reason }, false)
    },

    unblock(context) {
        return action(context, 'unblock', REQ_POST)
    },

    updatePages(context) {
        return action(context, 'updatePages', REQ_POST)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/account.js